import { RECOGNITION_MODE } from 'src/constants'

export const recognitionPath = (mode) => {
  return mode === RECOGNITION_MODE.CONVERSATION ? '/speak' : '/dictate'
}